import { Model } from '@/services/api/lib'

export default class Language extends Model {
  resource () {
    return 'settings/v1/languages'
  }

  defaults () {
    return {
      code: '',
      name: '',
      iso: '',
      flag: '',
      dir: '',
      default: false
    }
  }

  delete (code) {
    const config = {}
    config.url = `${this.endpoint()}/${code}`
    config.method = 'DELETE'

    return this.request(config)
  }
}
